import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: '首页', href: '#hero' },
  { label: '漫画分类', href: '#index' },
  { label: '焦点专题', href: '#carousel' },
  { label: '热门话题', href: '#topics' },
  { label: '平台特色', href: '#features' },
  { label: '读者热评', href: '#comments' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
            className="flex items-center gap-2 text-foreground-950 no-underline"
          >
            <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center">
              <i className="ri-planet-line text-2xl md:text-3xl text-primary-500"></i>
            </span>
            <span className="text-lg md:text-xl font-heading font-bold whitespace-nowrap text-foreground-950">
              星球漫画
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className={`whitespace-nowrap px-3 py-2 rounded-md text-sm font-medium transition-colors no-underline ${
                  item.label === '首页'
                    ? 'text-primary-600 hover:text-primary-700 hover:bg-primary-50'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer bg-transparent border-0"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className={`whitespace-nowrap px-3 py-2.5 rounded-md text-sm font-medium transition-colors no-underline ${
                  item.label === '首页'
                    ? 'text-primary-600 hover:bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}